import styled, { css } from 'styled-components';
import { rgba } from 'polished';
import { Modal } from 'antd';

// Import components
import { Button } from 'components/elements/atoms/Button/Button';

// Import styles
import { antModal, flex, customMinResponsive, size } from 'components/styles';

// Import types
import { AntModal } from 'types/libraries/antd';

export const ModalStyled = styled(Modal)<AntModal>`
	${antModal()}

	top: 8rem;
	width: 100% !important;

	${customMinResponsive(
		size.xsmall,
		css`
			width: 90% !important;
		`
	)}

	${customMinResponsive(
		size.large,
		css`
			width: 125rem !important;
		`
	)}

	.ant-modal-body {
		margin: 0rem;
		padding: 3rem 0;
	}

	.ant-modal-content {
		padding: 1rem;
		background-color: rgb(13, 15, 19) !important;
		border-radius: 0;

		${customMinResponsive(
			size.xsmall,
			css`
				padding: 2rem;
			`
		)}

		${customMinResponsive(
			size.large,
			css`
				padding: 4rem 8rem;
			`
		)}
	}

	.ant-modal-title {
		font-size: 2.6rem !important;
		color: ${({ theme }) => theme.white} !important;
		margin: 0 !important;

		${customMinResponsive(
			size.semi,
			css`
				font-size: 3rem !important;
			`
		)}
	}

	.ant-modal-close {
		position: absolute;
		top: 0;
		right: 0;

		svg {
			width: 2rem;
			height: 2rem;
		}

		${customMinResponsive(
			size.xsmall,
			css`
				top: 1rem;
				right: 1rem;

				svg {
					width: 2.8rem;
					height: 2.8rem;
				}
			`
		)}

		${customMinResponsive(
			size.large,
			css`
				top: 6.4rem;
				right: 2.1rem;
			`
		)}
	}
`;

export const ContentWrapper = styled.div`
	width: 100%;
	margin: 0 auto;
	${flex({ fd: 'column', jc: 'flex-start', ai: 'flex-end' })};

	button {
		margin-top: 4.5rem;
		padding: 1.3rem 6rem;
	}
`;

export const Form = styled.form`
	width: 100%;
`;

export const Info = styled.p`
	font-size: 1.4rem;
	color: ${({ theme }) => rgba(theme.white, 0.6)};
	line-height: 2.6rem;
	align-self: self-start;
	margin-bottom: 1.5rem;
`;

export const AgreementsWrapper = styled.div`
	padding: 1.5rem 1rem 2.5rem 0;

	${customMinResponsive(
		size.semi,
		css`
			padding: 3rem 2rem 5rem 0;
			max-width: 50%;
		`
	)}
`;

export const AgreementsList = styled.ul`
	${flex({ fd: 'column', ai: 'flex-start' })}
	list-style: none;
	gap: 1.6rem;
	width: 100%;
`;

export const Error = styled.span`
	font-size: 1.2rem;
	color: ${({ theme }) => theme.form.color.error};
	line-height: 1.8rem;
	display: block;
	margin-top: 1rem;
`;

export const StyledButton = styled(Button)`
	width: auto;
`;
